module.exports = __webpack_public_path__ + "img/index-mobile-background.5455e661.jpg";